import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PROGRAM_FEATURE_KEY, ProgramState } from './program.reducer';

export const selectProgramState = createFeatureSelector<ProgramState>(PROGRAM_FEATURE_KEY);

export const selectPrograms = createSelector(selectProgramState, (state) => state?.data ?? null);
export const selectProgramDetail = createSelector(selectProgramState, (state) => state?.detail ?? null);
export const selectProgramsTotal = createSelector(selectProgramState, (state) => state?.total ?? 0);
export const selectProgramsQuery = createSelector(selectProgramState, (state) => state?.query ?? null);
export const selectProgramsLoading = createSelector(selectProgramState, (state) => state?.loading ?? false);
export const selectProgramsError = createSelector(selectProgramState, (state) => state?.error ?? null);
